import React from "react";
import {Tabs} from "antd";
import Categories from "./categories";
import Services from "./services";


export default function CategoriesTable() {

    return (
        <>
            <Tabs defaultActiveKey={"1"} items={[
                {
                    key: '1',
                    label: 'Categories',
                    children: <Categories/>
                },
                {
                    key: '2',
                    label: 'Services',
                    children: <Services/>
                }]}/>
        </>
    );
}
